import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Base } from '../../Modal/rn';
import { safe_area_insets_bottom } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var Popup = function Popup(props) {
  var _props$isShowKeyborad = props.isShowKeyborad,
    isShowKeyborad = _props$isShowKeyborad === void 0 ? false : _props$isShowKeyborad;
  return props.active ? /*#__PURE__*/React.createElement(Base, _extends({}, props, {
    type: "popup",
    modalContainerStyle: [styles.popup, props.modalContainerStyle],
    contentContainerStyle: [props.contentContainerStyle, isShowKeyborad ? {} : {
      paddingBottom: safe_area_insets_bottom
    }]
  })) : null;
};
var styles = CustomStyleSheet({
  popup: {
    width: '100%'
  }
});